import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { SwapVert } from '@mui/icons-material'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { ITender } from 'types/tender'
import { formatTimeStampToStandartDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'

const StyledTableCell = styled(TableCell)({
  fontSize: '14px !important',
})
const StyledLink = styled(Link)({
  fontSize: '14px !important',
  textDecoration: 'none',
  color: 'rgb(3, 34, 76)',
})

function Row(props: { row: ITender; index: number }) {
  const { row, index } = props
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <StyledTableCell align="center">{index + 1}</StyledTableCell>
        <StyledTableCell>{row.organizationName}</StyledTableCell>
        <StyledTableCell>{row.name}</StyledTableCell>
        <StyledTableCell>
          {formatTimeStampToStandartDate(row.startTime)}
        </StyledTableCell>
        <StyledTableCell>
          {formatTimeStampToStandartDate(row.envelopeOpeningTime)}
        </StyledTableCell>
        <StyledTableCell>
          <StyledLink target="_blank" to={`/competitions/${row.id}`}>
            {t('detailed')}
          </StyledLink>
        </StyledTableCell>
      </TableRow>
    </React.Fragment>
  )
}

type Props = {
  tenders?: ITender[]
}

export function CompetitionTable({ tenders }: Props) {
  const { t } = useTranslation()

  return (
    <Box sx={{ overflow: 'auto' }}>
      <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
        <TableContainer component={Box}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <SwapVert
                    sx={{
                      color: '#8a94a6',
                      fontSize: '22px',
                    }}
                  />
                </TableCell>
                <TableCell>{t('tender-organization-name')}</TableCell>
                <TableCell>{t('procurement-method')}</TableCell>
                <TableCell>{t('startDate')}</TableCell>
                <TableCell>{t('envelope-open-date')}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {tenders?.map((row, index) => (
                <Row key={row.id} row={row} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
